module.exports = __webpack_public_path__ + "static/media/RusselReit.66edce66.png";